import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_BANK_ACCOUNT_INCOMES = 'REQUEST_BANK_ACCOUNT_INCOMES'
export const RECEIVE_BANK_ACCOUNT_INCOMES = 'RECEIVE_BANK_ACCOUNT_INCOMES'
export const SAVE_BANK_ACCOUNT_INCOME = 'SAVE_BANK_ACCOUNT_INCOME'

export const requestBankAccountIncomes = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_BANK_ACCOUNT_INCOMES, data: { taxReturnId } })

    axios
        .get(`/bankaccountincomes?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receiveBankAccountIncomes({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveBankAccountIncomes({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveBankAccountIncomes({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveBankAccountIncomes = (data) => ({ type: RECEIVE_BANK_ACCOUNT_INCOMES, data })

export const saveBankAccountIncome = (data) => (dispatch) => {
    dispatch({ type: SAVE_BANK_ACCOUNT_INCOME, data })

    const { id } = data

    return axios
        .put(`/bankaccountincomes/${id}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveBankAccountIncomes({
                    items: [responseData],
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const updateAndSaveBankAccountIncomes = (data) => (dispatch) => {
    dispatch(receiveBankAccountIncomes({ items: [data] }))
    return dispatch(saveBankAccountIncome(data)).catch(() => {})
}
